import script from "./BlockTransactionTaxReceiptRequested.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTransactionTaxReceiptRequested.vue?vue&type=script&setup=true&lang=js"

import "./BlockTransactionTaxReceiptRequested.vue?vue&type=style&index=0&id=27ad1662&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ad1662"]])

export default __exports__